// import cfg from "../cfg";
import axios from 'axios';
import Router from '../router/index';
import { Toast } from 'vant';
import Cookies from 'js-cookie';
import jwt_decode from 'jwt-decode';
import Vue from 'vue';

Vue.use(Router);

const instance = axios.create({
  // baseURL: 'https://api.aqjsjx.com.cn', //hui取代在反代理那里配置的/api吗？
  timeout: 10000,
});

// 添加请求拦截器
instance.interceptors.request.use(config => {
  //登录前需要清token
  if (config.url === '/api/oauth/token') {
    let names = window.location.hostname.split('.');
    if (names.length > 2) {
      names[0] = '';
    }
    let domain = names.join('.');
    Cookies.remove('anqiu_education_token', {domain: domain});
    Cookies.remove('anqiu_education_refresh_token', {domain: domain});
    Cookies.remove('u_info', {domain: domain});
  }
  // 发起请求前做些什么
  if (config.params && config.params['type'] && config.params['type'] !== 'noLoading') {
    Toast.loading({
      mask: false,
      duration: 0,
      forbidClick: 0,
      message: '加载中...'
    });
  }

  let anqiu_education_token = Cookies.get('anqiu_education_token');
  if (anqiu_education_token && anqiu_education_token !== 'undefined') {
    let exp = jwt_decode(anqiu_education_token).exp;
    let NowTime = new Date().valueOf();
    let time = new Date(0).setUTCSeconds(exp);
    // let time = 1590715488000;
    if (time > NowTime) {
      //登录中
      console.log('登陆中。。。');
    } else {
      //过期
      console.log('登录失效。。。');
      Cookies.remove('u_info');
      Toast('登录认证信息已失效！请重新登录！');
      Router.push('/login').catch(err => err);
      // next('/login')
    }
  }

  return config;
}, (error) => {
  // 请求错误
  Toast('请求错误，请稍后重试');
  // Toast.clear();
  return Promise.reject(error);

});

//添加响应拦截器
instance.interceptors.response.use(function (response) {
  Toast.clear();
  return response.data;
}, function (error) {
  if (error && error.response) {
    if (error.response.status === 401 || error.response.status === 403) {
      Router.push('/401').catch(err => err);
    } else if (error.response.status === 404 && error.response.data.consumerMessage === '暂无数据！') {
      //暂无数据不弹错误提示
    } else {
      Toast(error.response.data.consumerMessage);
    }
  } else {
    Toast('请求发生错误' + error);
  }
  return Promise.reject(error);

});

export default instance;
